import { StyledGridCol, StyledGridRow } from "@/common/styles";
import Button from "@/common/elements/Button";
import Table from "@/common/elements/Table";
import { useSelector } from "react-redux";
import { getFlagTableRows, getDisplayInvolvements } from "./flagUtils";

const flagGangMemberDetailsHeaders = [
  { key: "flag", text: "Flag" },
  { key: "summaryDescription", text: "Summary Description" },
  { key: "relatedRecordSummary", text: "Related Record Summary" },
  { key: "expirationDate", text: "Expiration Date" },
];

const FlagGangMemberDetails = () => {
  const bookings = useSelector((state) => state?.bookings?.bookings);
  const jacketFlags = useSelector((state) => state?.bookings?.jacketFlags);
  const rows = getFlagTableRows(
    getDisplayInvolvements(bookings, jacketFlags),
    "FLAGTYPES_GANG",
    "Gang Member",
    bookings,
  );

  return (
    <>
      <StyledGridRow justify={"space-between"}>
        <StyledGridCol></StyledGridCol>
        <StyledGridCol>
          <Button>Delete</Button>
        </StyledGridCol>
      </StyledGridRow>

      <Table headers={flagGangMemberDetailsHeaders} data={rows} style={{ marginTop: "15px" }} />
    </>
  );
};
export default FlagGangMemberDetails;
